/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Left_Seemly_Skunk_AnimateInputs */

const fr_left_seemly_skunk_animate = /** @type {(inputs: Left_Seemly_Skunk_AnimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/**

* @param {Left_Seemly_Skunk_AnimateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const left_seemly_skunk_animate = /** @type {((inputs?: Left_Seemly_Skunk_AnimateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Left_Seemly_Skunk_AnimateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_left_seemly_skunk_animate(inputs)
});